import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c441bc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sukangcode" }
const _hoisted_2 = { class: "fujian1" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { class: "guiji" }
const _hoisted_5 = { class: "fujian2" }
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = { class: "button" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("更改")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_field, {
              required: "",
              label: "个人苏康码"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  modelValue: _ctx.uploader1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploader1) = $event)),
                  "after-read": _ctx.afterRead1,
                  onDelete: _ctx.deleteUrlHealth
                }, null, 8, ["modelValue", "after-read", "onDelete"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("p", _hoisted_3, " 已过14天有效期,请重新上传 ", 512), [
              [_vShow, !_ctx.flag1]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_field, {
              required: "",
              label: "进场前14日行动轨迹图"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  modelValue: _ctx.uploader2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploader2) = $event)),
                  "after-read": _ctx.afterRead2,
                  onDelete: _ctx.deleteUrlTrackUrl
                }, null, 8, ["modelValue", "after-read", "onDelete"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("p", _hoisted_6, " 已过14天有效期,请重新上传 ", 512), [
              [_vShow, !_ctx.flag1]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.flag)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                block: "",
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_van_button, {
                key: 1,
                block: "",
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}